// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Options__container___32HG5{margin:128px 24px 0}.Options__wrapper___2arjt{text-align:center}.Options__title___12fdJ{color:inherit;font-weight:500;font-size:40px;line-height:56px;padding:0 10px;color:#2c2302;font-weight:200}.Options__description___1wVP9{color:inherit;font-weight:400;font-size:16px;line-height:24px;color:#6b6651}.Options__option_description___2sbRK{color:inherit;font-weight:400;font-size:20px;line-height:32px;margin:40px 0;font-weight:#2c2302}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "Options__container___32HG5",
	"wrapper": "Options__wrapper___2arjt",
	"title": "Options__title___12fdJ",
	"description": "Options__description___1wVP9",
	"option_description": "Options__option_description___2sbRK"
};
module.exports = ___CSS_LOADER_EXPORT___;
